// errorHandler.ts

export const handleServiceError = (error: any) => {
    if (error instanceof Error) {
      console.error('Error durante la solicitud:', error.message);
    } else {
      console.error('Error desconocido:', error);
    }
  };
  